/* The icon of a file by its content type, for a task's attachments. */
export const fileIcon = (contentType: string): string => {
    const type = (contentType ?? '').toLowerCase()

    if (type.startsWith('image/')) return 'i-lucide-file-image'
    if (type === 'application/pdf') return 'i-lucide-file-text'
    if (type.includes('spreadsheet') || type.includes('excel') || type === 'text/csv') return 'i-lucide-file-spreadsheet'
    if (type.startsWith('video/')) return 'i-lucide-file-video'
    if (type.includes('zip') || type.includes('compressed')) return 'i-lucide-file-archive'

    return 'i-lucide-file'
}
